import request from '@/config/axios'

// 获取系统设置
export const GetSystemSetting = (params) => {
  return request.get({
    url: 'system/general/setting',
    params,
    baseUrl:'m2i'
  })
}

export const SetSystemSetting = (data) => {
   return request.post({
     url: 'system/general/setting',
     data,
    baseUrl:'m2i'
   })
}

export const AddArea = (data) => {
  return request.post({
    url: 'area/monitor/area',
    data,
    baseUrl:'m2i'
  })
}

export const UpdateArea = (data) => {
  return request.put({
    url: 'area/monitor/area',
    data,
    baseUrl:'m2i'
  })
}

// 根据groupId 获取监控分区列表
export const GetAreas = (params) => {
  return request.get({
    url: 'area/monitor/area',
    params,
    baseUrl:'m2i'
  })
}

export const DeleteAreaById = (id) => {
  return request.delete({
    url: `area/monitor/area?id=${id}`,
    baseUrl:'m2i'
  })
}

// 根据areaId 获取位置图列表
export const GetDevposByAreaId = (params) => {
  return request.get({
    url: `area/monitor/devpos/list`,
    params,
    baseUrl:'m2i'
  })
}

export const SaveDevpos = (data) => {
  return request.put({
    url: 'area/monitor/devpos',
    data,
    baseUrl:'m2i'
  })
}

export const GetDevposById = (id) => {
  return request.get({
    url: `/area/monitor/devpos`,
    params:{
      id
    },
    baseUrl:'m2i'
  })
}
export const DeleteDevposById = (id) => {
  return request.delete({
    url: `area/monitor/devpos?id=${id}`,
    baseUrl:'m2i'
  })
}
//
export const GetDevposByNodeId = (nodeId) => {
  return request.get({
    url: `/area/monitor/devpos/ids`,
    params:{
      nodeId
    },
    baseUrl:'m2i'
  })
}

export const GetLang = (params) => {
  return request.get({
    url: 'i18n-data',
    baseUrl:'m2i',
    params
  })
}

export const RegisterLang = (data) => {
  return request.post({
    url: '/i18n-data',
    baseUrl:'m2i',
    data:data
  })
}